export interface ApiConfig {
  serverUrl: string;
  apiVersion: string;
  deviceUdid: string;
  clientVersion: string;
  clientPlatform: string;
  hostOrigin?: string;
}

let _config: ApiConfig | null = null;

export function setApiConfig(config: Partial<ApiConfig>): void {
  _config = _config ? { ..._config, ...config } : (config as ApiConfig);
}

export function getApiConfig(): ApiConfig {
  if (!_config) {
    throw new Error('API config not initialized. Call setApiConfig() first.');
  }
  return _config;
}

const DEVICE_UDID_KEY = 'xm_device_udid';

export function getDeviceUDID(): string {
  let udid = localStorage.getItem(DEVICE_UDID_KEY);
  if (!udid) {
    udid = crypto.randomUUID();
    localStorage.setItem(DEVICE_UDID_KEY, udid);
  }
  return udid;
}
